import React from "react";
import { Box } from "@mui/material";
import LearnStage from "./LearnStage";
import RecallStage from "./RecallStage";
import WriteStage from "./WriteStage";

function PracticeCardStage(props) {
  const { practiceCard, practicePhase, practiceMeta } = props;

  return (
    <Box
      sx={{
        position: "relative",
        p: { xs: 2.2, md: 2.25 },
        borderRadius: "24px",
        border: `1px solid ${practiceMeta.accent}22`,
        bgcolor: "#fffefd",
        boxShadow: "0 28px 70px -44px rgba(19, 43, 63, 0.58)",
        overflow: "hidden",
      }}
    >
      {practicePhase === "learn" && <LearnStage practiceCard={practiceCard} practiceMeta={practiceMeta} />}
      {practicePhase === "recall" && <RecallStage {...props} />}
      {practicePhase === "write" && <WriteStage {...props} />}
    </Box>
  );
}

export default PracticeCardStage;
